module.exports = __webpack_public_path__ + "static/img/2-2-3.6aed6de3.jpg";